import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    justify-content: flex-end;
    flex-shrink: 0;
`;
